import { Slot } from 'radix-ui';

/**
 * Marks which child of an `asChild` parent is the element to merge onto, so the
 * parent can place its own content on either side of it.
 */
export const Slottable = Slot.Slottable;
